import { render, staticRenderFns } from "./LookingForPartners.vue?vue&type=template&id=59eb429d&scoped=true"
import script from "./LookingForPartners.vue?vue&type=script&lang=js"
export * from "./LookingForPartners.vue?vue&type=script&lang=js"
import style0 from "./LookingForPartners.vue?vue&type=style&index=0&id=59eb429d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eb429d",
  null
  
)

export default component.exports